export default "__VITE_ASSET__BgaPL$D___"